<template>
  <Loader :loaded="loaded" />
  <div v-if="loaded" class="hidden lg:flex lg:mx-8 my-1">
    <div class="mx-2 pt-1 font-bold text-red-800">
      Display : 
    </div>
    <div v-bind:class="{ 'bg-green-400': !filtered}" 
      class="rounded-full bg-gray-400 text-white px-4 py-1 cursor-pointer font-medium" v-on:click="filterBy('ALL')">
      <span v-if="!filtered">
        <i class="fas fa-check"></i>
      </span>
      All
    </div>
    <div class="rounded-full ml-1 bg-yellow-500 text-white px-4 py-1 cursor-pointer font-medium" v-on:click="filterBy('comp')">
      <span v-if="filter == 'comp'">
        <i class="fas fa-check"></i>
      </span>
      compilation
    </div>
    <div class="rounded-full ml-1 bg-blue-500 text-white px-4 py-1 cursor-pointer font-medium" v-on:click="filterBy('ep')">
      <span v-if="filter == 'ep'">
        <i class="fas fa-check"></i>
      </span>
      EP
    </div>
    <div class="rounded-full ml-1 bg-blue-500 text-white px-4 py-1 cursor-pointer font-medium" v-on:click="filterBy('single')">
      <span v-if="filter == 'single'">
        <i class="fas fa-check"></i>
      </span>
      single
    </div>
    <div class="rounded-full ml-1 bg-purple-500 text-white px-4 py-1 cursor-pointer font-medium" v-on:click="filterBy('remix')">
      <span v-if="filter == 'remix'">
        <i class="fas fa-check"></i>
      </span>
      remix
    </div>
    <div class="rounded-full ml-1 bg-purple-500 text-white px-4 py-1 cursor-pointer font-medium" v-on:click="filterBy('feat')">
      <span v-if="filter == 'feat'">
        <i class="fas fa-check"></i>
      </span>
      featuring
    </div>
  </div>

  <div class="grid grid-cols-3 lg:grid-cols-8 lg:mx-8 my-1">
    <Single v-for="single in filteredSingles" :key="single.id" :singleData="single" />
  </div>
</template>
<script>
  import axios from 'axios'
  import Single from './Single'
  import Loader from '../common/Loader'

  export default {
    components: { Single, Loader },
    name: 'SingleList',
    data: function() {
      return { singles: [], filteredSingles: [], loaded: false, filtered: false, filter: ''}
    },
    methods: {
      getDelay: function(single) {
        if (this.filtered)
          return 0;
        return single.id * 100;
      },
      filterBy: function(type) {
        if(type == 'ALL') {
          this.filtered = false;
          this.filter = '';
          this.filteredSingles = this.singles;
          return;
        }
        if (type == 'comp') {
          this.filteredSingles = this.singles.filter(s => s.type == 'COMP')
          this.filter = 'comp';
        }
        if (type == 'ep') {
          this.filteredSingles = this.singles.filter(s => s.type == 'EP')
          this.filter = 'ep';
        }
        if (type == 'single') {
          this.filteredSingles = this.singles.filter(s => s.type == 'Single')
          this.filter = 'single';
        }
        if (type == 'remix') {
          this.filteredSingles = this.singles.filter(s => s.type == 'REMIX')
          this.filter = 'remix';
        }
        if (type == 'feat') {
          this.filteredSingles = this.singles.filter(s => s.type == 'FEAT')
          this.filter = 'feat';
        }
        this.filtered = true;
      }
    },
    mounted: function() {
        axios
          .get('/files/singles.json')
          .then(response => { 
            this.singles = response.data.sort((a, b) => { return a.releaseDate > b.releaseDate ? -1 : 1});
            for (var i = 0; i < this.singles.length; i++) {
              this.singles[i].id = i;
            }
            this.filteredSingles = this.singles;
            this.loaded = true
          })
    }
  }
</script>